import $okgportal_api from "@/shared/client/okgportal.client";
import { BaseOkgportalResponce } from "@/shared/model/api.types";
import { PlanTypeInterface } from "../model/plan.types";

class PlanTypeApi {
  async getPlanTypes(){
    try {
      const response = await $okgportal_api.get<BaseOkgportalResponce<PlanTypeInterface[]>>('/plan/types');
      return response.data
    } catch (error) {
      throw error
    }
  }
}

const planTypeApi = new PlanTypeApi();
export default planTypeApi;